module.exports = __webpack_public_path__ + "img/food.6d7879d7.png";